export default __webpack_public_path__ + "static/ocna_ambulancia_cennik-0310afecbe73572304611b50d070b815.pdf";